import React from 'react';
import './NavigationPanel.css';
import ReportSection from './ReportSection';

interface ReportItem {
  id: number;
  name: string;
  url: string;
}

interface NavigationPanelProps {
  customReports: ReportItem[];
  favoriteReports: ReportItem[];
  customTitle?: string;
  favoriteTitle?: string;
}

const NavigationPanel: React.FC<NavigationPanelProps> = ({
  customReports,
  favoriteReports,
  customTitle,
  favoriteTitle,
}) => {

  return (
    <div className="panel">
      <ReportSection title={customTitle || 'Custom'} reports={customReports} reportType='Custom' />
      <hr className="sectionDivider my-0" />
      <ReportSection title={favoriteTitle || 'Favorites'} reports={favoriteReports} reportType='Favorites' />
    </div>
  );
};

export default NavigationPanel;
